<template>
	<el-footer>
		<el-container>
			<el-row type="flex" justify="space-around" style="width: 100%;margin-top: 20px">
				<el-col :span="6" style="text-align: center">
					<p>AVISO DE PRIVACIDAD</p>
				</el-col>
				<el-col :span="6" style="text-align: center">
					<p>CONTACTO</p>
				</el-col>
				<el-col :span="6" style="text-align: center">
					<p>Teléfono: (800) 8412020</p>
				</el-col>
			</el-row>
		</el-container>
	</el-footer>
</template>

<script>
	export default {

	}
</script>

<style>

</style>